export type Status = "pending" | "running" | "pass" | "fail";

export interface Check {
  status: Status;
  detail: string;
}

export type Checks = Record<string, Check>;
export type UpdateCheck = (key: string, check: Check) => void;

export const SYSTEM_CHECKS = [
  { key: "browser", label: "Browser" },
  { key: "os", label: "Operating System" },
  { key: "screen", label: "Screen Resolution" },
  { key: "internet", label: "Internet Connection" },
  { key: "support", label: "Proctoring Support" },
];

export const DEVICE_CHECKS = [
  { key: "camera", label: "Camera" },
  { key: "face", label: "Face Scan" },
  { key: "microphone", label: "Microphone" },
  { key: "recording", label: "Audio Recording" },
];

/** How long a single face must stay in view before the scan passes (ms) */
export const HOLD_DURATION_MS = 1500;
/** Length of the sample audio recording (seconds) */
export const RECORDING_SECONDS = 5;
/** RMS level above which the microphone is considered to be picking up sound */
export const MIC_RMS_THRESHOLD = 0.02;
/** Frames above the threshold needed for the recording to count as audible */
export const MIC_REQUIRED_FRAMES = 10;

/** Give up waiting for a face after this long (ms) */
export const FACE_TIMEOUT_MS = 30000;
/** Minimum time each system check stays on screen before moving to the next (ms) */
export const SYSTEM_STEP_MS = 700;

export const NOT_STARTED: Check = { status: "pending", detail: "Not started" };

export const initialChecks = (items: { key: string }[]): Checks =>
  items.reduce((acc, { key }) => ({ ...acc, [key]: NOT_STARTED }), {});

export const isSettled = (check: Check) => check.status === "pass" || check.status === "fail";
